import { create } from 'zustand'

interface ThemeType {
    theme: boolean;
    setTheme: (theme: boolean) => void;
}

const getInitialTheme = (): boolean => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme !== null ? JSON.parse(savedTheme) : true;
};

export const useTheme = create<ThemeType>((set) => ({
    theme: getInitialTheme(),
    setTheme: (theme) => {
        localStorage.setItem('theme', JSON.stringify(theme));
        set({ theme: theme });
    },
}))